<template>
<div v-if="computedClienteClickdayIt">

	<v-container fluid>
		<v-toolbar flat dense :color="scdColor">
			<v-toolbar-items>
				<v-btn :to="{ name: 'gaming-dashboard-route' }" text color="white">
					DASHBOARD
				</v-btn>
				<v-btn
					:to="{ name: 'gaming-click-day-route' }"
					text color="white"
				>
					CLICK DAY
				</v-btn>
				<v-btn v-if="computedIsUtenteAttivo" :to="{ name: 'gaming-game-day-route' }" text color="white">
					GAME DAY
				</v-btn>
				<v-btn
					v-if="computedIsUtenteAttivo || amIAdminOrTeamleader || computedAmIDeveloper"
					:to="{ name: 'gaming-classifica-route' }"
					text color="white"
				>
					CLASSIFICA
				</v-btn>
				<v-btn
					v-if="amIAdminOrTeamleader"
					:to="{ name: 'compensi-route' }" text color="white"
				>
					COMPENSI
				</v-btn>
				<v-btn
					v-if="computedAmIAdmin"
					:to="{ name: 'assistente-virtuale-route' }" text color="white">
					<v-icon left>
						mdi-creation
					</v-icon>
					VIRTUAL COORDINATOR
				</v-btn>
				<v-btn v-if="computedIsUtenteAttivo"
					:to="{ name: 'consigli-route' }" text color="white">
					CONSIGLI
				</v-btn>
				<v-btn
					v-if="computedAmIAdmin"
					:to="{ name: 'procedure-route' }" text color="white">
					PROCEDURE
				</v-btn>
			</v-toolbar-items>
		</v-toolbar>
	</v-container>

	<router-view></router-view>

  <!--<v-row class="justify-center my-4">-->
  <!--  <div style="font-weight:700; font-size:25px; color:#434343">Profilo Cliccatore{{ idCliccatore != null && usernameCliccatore != null ? `: ${usernameCliccatore}` : null }}</div>-->
  <!--</v-row>-->

	<!--<v-tabs fixed-tabs>-->
	<!--	<v-tab>-->
	<!--		<span class="font-weight-bold">Dashboard</span>-->
	<!--	</v-tab>-->
	<!--	<v-tab v-if="amIAdminOrTeamleader">-->
	<!--		<span class="font-weight-bold">Click Day</span>-->
	<!--	</v-tab>-->
	<!--	<v-tab>-->
	<!--		<span class="font-weight-bold">Game Day</span>-->
	<!--	</v-tab>-->
	<!--	<v-tab>-->
	<!--		<span class="font-weight-bold">Classifica</span>-->
	<!--	</v-tab>-->

	<!--	<v-tab-item>-->
	<!--		<dashboard-gaming-component-->
	<!--			:idCliccatore="idCliccatore"-->
	<!--		></dashboard-gaming-component>-->
	<!--	</v-tab-item>-->
	<!--	<v-tab-item v-if="amIAdminOrTeamleader">-->
	<!--		&lt;!&ndash;	&ndash;&gt;-->
	<!--	</v-tab-item>-->
	<!--	<v-tab-item>-->
	<!--		<lista-gamedays-gaming-component-->
	<!--			:idCliccatore="idCliccatore"-->
	<!--		></lista-gamedays-gaming-component>-->
	<!--	</v-tab-item>-->
	<!--	<v-tab-item>-->
	<!--		<classifica-gaming-component-->
	<!--			:idCliccatore="idCliccatore"-->
	<!--		></classifica-gaming-component>-->
	<!--	</v-tab-item>-->
	<!--</v-tabs>-->

</div>
</template>

<script>
import mixin from '../../mixins';

export default {
  props: ['idCliccatore'],
  data() {
    return {
      tab: null,
    }
  },

  methods: {

  }
}
</script>

<style lang="scss" scoped>

</style>